export const state = {
    importers: [],
    systemImporter: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/importers/state.js